import {createQueryKeys} from "../shared/query/query-keys";

export const authKeys = {
  ...createQueryKeys("auth"),
  csrf: () => ["auth", "csrf"] as const,
  session: () => ["auth", "session"] as const,
};
